// tslint:disable

import * as React from 'react';
import { CheckboxField } from '../../components/fields/checkbox.field';
import { InputField } from '../../components/fields/input.field';
import { MediaItemField } from '../../components/fields/media-item.field';
import { WysiwygField } from '../../components/fields/wysiwyg.field';
import { FormLib } from '../../components/libs/form.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { Validators } from '../../components/libs/Validators';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { IriPresenter } from '../../components/structurals/presenters/iri-presenter';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';

export class DefaultCompanyArticle extends React.Component<any, any> {

    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    render() {
        return (
            <ResourceLoader entity="company-article" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div>
                <div className="col-md-9 realtive col-xs-12">
                    <LoaderComponent isLoading$={this.executor.loading$}/>
                    <ToggleBoxComponent title={this.props.IS_CREATE ? 'Create new Article to the Company' : <IriPresenter iri={form.fields.company.value} path='name'/>} color='green' alwaysOpen={true}>
                        <div className="row">
                            <div className="col-xs-12">
                                <InputField
                                    field={form.fields.title}
                                    validators={[
                                        Validators.required('Required')
                                    ]}/>

                                <InputField
                                    field={form.fields.link}/>

                                <InputField type='number'
                                            field={form.fields.sortNo}/>

                                <WysiwygField
                                    title='Body'
                                    field={form.fields.body}
                                />

                                <CheckboxField
                                    field={form.fields.featured}
                                />
                                <button className='btn btn-primary pull-left' onClick={() => this.saveForm(form)}>Save</button>
                            </div>
                        </div>
                    </ToggleBoxComponent>
                </div>
                <div className="col-md-3 realtive col-xs-12">
                    <ToggleBoxComponent title="Cover">
                        <MediaItemField field={form.fields.cover}/>
                    </ToggleBoxComponent>


                    {/*<ToggleBoxComponent title='Valami' alwaysOpen={true}>*/}
                    {/*<IriField*/}
                    {/*field={form.fields.company}*/}
                    {/*defaultValue={this.props.CONFIG ? `/company/${this.props.CONFIG.company}` : ''}*/}
                    {/*disabled={this.props.CONFIG && !!this.props.CONFIG.company}*/}
                    {/*defaultAll={false}*/}
                    {/*className='col-xs-12'*/}
                    {/*itemRender={(item: any) => item.name}/>*/}
                    {/*</ToggleBoxComponent>*/}

                    <ToggleBoxComponent title="Properties" alwaysOpen={true}>

                        {/*<DatepickerField*/}
                        {/*className="col-xs-12"*/}
                        {/*field={form.fields.createdAt}*/}
                        {/*disabled={true}/>*/}

                        {/*<DatepickerField*/}
                        {/*className="col-xs-12"*/}
                        {/*field={form.fields.updatedAt}*/}
                        {/*disabled={true}/>*/}


                        <IriPresenter iri={form.fields.createdBy.value} path="surName"/>

                    </ToggleBoxComponent>

                </div>
            </div>}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.company-article.tsx